import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import { breakpoint, getColor } from '../../shared/theme'
import Heading from '../../elements/typography/sectionHeading'
import ContentContainer from '../contentContainer'
import BackgroundImage from '../backgroundImage'
import orangeChevron from '../../assets/images/orange-chevron.png'

const SectionWrapper = styled.section`
	background-color: ${getColor('white')};

	@media ${breakpoint('tablet')} {
		background-color: ${getColor('black')};
	}
`

const SectionHeader = styled.div`
	padding: 54px 0;

	@media ${breakpoint('tablet')} {
		padding: 86px 0;
	}

	@media ${breakpoint('laptop')} {
		padding: 130px 0 71px;
	}
`

const HeadingWrapper = styled.div`
	width: 57%;
	text-align: center;
	margin: 0 auto;
	color: ${getColor('black')};

	@media ${breakpoint('tablet')} {
		width: 100%;
		text-align: left;
		color: ${getColor('white')};
	}
`

const SectionBody = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: -12px;

	@media ${breakpoint('tablet')} {
		padding-bottom: 86px;
		margin-bottom: 0px;
	}

	@media ${breakpoint('laptop')} {
		padding-bottom: 177px;
	}
`

const RepeaterItem = styled.div`
	width: 100%;
	margin-bottom: 70px;

	@media ${breakpoint('tablet')} {
		display: flex;
		margin-bottom: 0px;
		width: 24.62%;
		align-items: flex-start;
		justify-content: space-between;
	}
`

const RepeaterContentWrapper = styled.div`
	@media ${breakpoint('tablet')} {
		width: calc(100% - 16px);
	}
`

const Icon = styled.img`
	display: none;

	@media ${breakpoint('tablet')} {
		margin-top: 118px;
		height: auto;
		width: auto;
		display: block;
	}
`

const ImageWrapper = styled.div`
	width: 100%;
	aspect-ratio: 1.038;
`

const CopyWrapper = styled.div`
	margin-top: 26px;
	color: ${getColor('black')};

	@media ${breakpoint('tablet')} {
		margin-top: 50px;
		color: ${getColor('white')};
	}
`

export const Copy = styled.p`
	font-size: 14.8px;
	line-height: 17.8px;
	font-weight: 300;
	margin-bottom: 0px;
	color: ${getColor('black')};

	@media ${breakpoint('mobile')} {
		font-size: 18px;
		line-height: 22px;
	}

	@media ${breakpoint('tablet')} {
		color: ${getColor('white')};
	}

	@media ${breakpoint('laptop')} {
		font-size: 16px;
		line-height: 20px;
	}
`

const Title = styled.h3`
	font-size: 20px;
	font-weight: 700;
	line-height: 24px;
	margin-bottom: 20px;
	color: ${getColor('black')};

	@media ${breakpoint('tablet')} {
		color: ${getColor('white')};
		font-size: 40px;
		line-height: 48px;
		font-weight: 800;
		margin-bottom: 30px;
	}
`

export const ProcessBlock = ({ heading, repeater }) => {
	const imageRef = useRef()
	const [iconMargin, setIconMargin] = useState()

	useEffect(() => {
		if (imageRef.current) {
			const initIconMargin = () => {
				setIconMargin(imageRef.current.offsetHeight / 2 - 6)
			}

			setIconMargin(imageRef.current.offsetHeight / 2 - 6)

			// Add event listener for window resize
			window.addEventListener('resize', initIconMargin)

			// Clean up the event listener on component unmount
			return () => {
				window.removeEventListener('resize', initIconMargin)
			}
		}
	}, [imageRef.current])

	return (
		<SectionWrapper>
			<ContentContainer>
				<SectionHeader>
					<HeadingWrapper>
						<Heading>{heading && heading}</Heading>
					</HeadingWrapper>
				</SectionHeader>

				<SectionBody>
					{repeater &&
						repeater.map((content, index) => {
							return (
								<RepeaterItem key={index} index={index}>
									<RepeaterContentWrapper>
										<ImageWrapper ref={imageRef}>
											<BackgroundImage backgroundImage={content.image} />
										</ImageWrapper>
										<CopyWrapper>
											<Title>{content.title && content.title}</Title>
											<Copy styles={{ marginBottom: '0px' }}>
												{content.copy && content.copy}
											</Copy>
										</CopyWrapper>
									</RepeaterContentWrapper>
									{index < repeater.length - 1 && (
										<Icon
											src={orangeChevron}
											alt="Orange right arrow"
											style={{ marginTop: `${iconMargin}px` }}
										/>
									)}
								</RepeaterItem>
							)
						})}
				</SectionBody>
			</ContentContainer>
		</SectionWrapper>
	)
}

export default ProcessBlock
